export default __webpack_public_path__ + "static/media/thai_qr_payment.7a721301.png";